import * as components from "./components"

export default function SplitPaneModePlugin() {
  return {
    // statePlugins: {
    //   layout: {
    //     actions,
    //     selectors,
    //   }
    // },

    components,
  }
}



// WEBPACK FOOTER //
// ./src/core/plugins/split-pane-mode/index.js